import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${space[6]} ${space[5]} ${space[5]};
  gap: ${space[5]};
`;

export const Title = styled.h2`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
`;

export const Item = styled.li`
  margin: 0;
  padding: 0;
`;

export const ItemButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${space[4]};
  width: 100%;
  padding: ${space[2]};
  background: ${({ $active }) => ($active ? colors.lighterGrey : 'transparent')};
  border: none;
  border-radius: ${layout.borderRadiusLg};
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }
`;

export const Thumbnail = styled.div`
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: ${layout.borderRadiusMd};
  overflow: hidden;
  background: ${colors.lightGrey};
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ThumbnailPlaceholder = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
`;

export const ItemLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
`;
